import React from 'react';
import ReactDOM from 'react-dom/client';
import { PrimeReactProvider } from 'primereact/api';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <PrimeReactProvider value={{ 
      unstyled: false,
      pt: {
        // Базовые настройки для лучшей интеграции с DaisyUI
      }
    }}>
      <App />
    </PrimeReactProvider>
  </React.StrictMode>
);
